class Alert {
    constructor(params) {
        this._params = params;
        this._text = params.text || '';
        this._create();
        this._remove = this._remove.bind(this);
        this._close = this._el.querySelector('.ui-alert-i__close');
        this._close.addEventListener('click', this._remove)
    }
    
    _create() {
        const node = document.createElement('span');
        node.classList.add('ui-alert-i');
        if (this._params.state) {
            node.dataset.state = this._params.state;
        }
        this._el = node;
        this._el.innerHTML = `<span class="ui-alert-i__text">${this._text}</span><button class="ui-alert-i__close"></button>`;
        const event = new CustomEvent('create.alert', {detail: {target: this._el}});
        document.dispatchEvent(event);
    }
    
    _remove() {
        const event = new CustomEvent('remove.alert', {detail: {target: this._el}, bubbles: true});
        this._el.dispatchEvent(event);
        this._el.remove();
    }
    
    getNode() {
        return this._el;
    }
    
    removeNode() {
        this._remove();
    }
}
